import { render, staticRenderFns } from "./ProjectNoteItem.vue?vue&type=template&id=338d35de&scoped=true"
import script from "./ProjectNoteItem.vue?vue&type=script&lang=js"
export * from "./ProjectNoteItem.vue?vue&type=script&lang=js"
import style0 from "./ProjectNoteItem.vue?vue&type=style&index=0&id=338d35de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338d35de",
  null
  
)

export default component.exports